
import * as fromAdmModelos from '../../../actions/AdmSiicart/Modelos/admModelos.action';

export interface AdmModeloState {
  Operacion: string;
  TipoR: string;
  Procesando: boolean;
  Respuesta: any;
  ErrorMessage: any | null;
}

export const initialState: AdmModeloState = {
    Operacion: '',
    TipoR: '',
    Procesando: false,
    Respuesta: null,
    ErrorMessage: null
  };

export function admModelosReducer(state = initialState, action: fromAdmModelos.AdmModeloAcciones): AdmModeloState {
    switch (action.type) {
      case fromAdmModelos.AdmModeloActionTypes.GET_ADM_MODELO: {
        return {
          ...state,
          Operacion: 'GetModelo',
          TipoR: '',
          Procesando: true,
          Respuesta: null,
          ErrorMessage: null
        };
      }
      case fromAdmModelos.AdmModeloActionTypes.SET_ADM_MODELO: {
        return {
          ...state,
          Operacion: 'SetModelo',
          TipoR: '',
          Procesando: true,
          Respuesta: null,
          ErrorMessage: null
        };
      }
      case fromAdmModelos.AdmModeloActionTypes.EDIT_ADM_MODELO: {
        return {
          ...state,
          Operacion: 'EditModelo',
          TipoR: '',
          Procesando: true,
          Respuesta: null,
          ErrorMessage: null
        };
      }
      case fromAdmModelos.AdmModeloActionTypes.DELETE_ADM_MODELO: {
        return {
          ...state,
          Operacion: 'DeleteModelo',
          TipoR: '',
          Procesando: true,
          Respuesta: null,
          ErrorMessage: null
        };
      }
      case fromAdmModelos.AdmModeloActionTypes.SUCESS_MODELO: {
        return {
          ...state,
          Operacion: 'SuccesModelo',
          TipoR: action.TipoR,
          Procesando: false,
          Respuesta: action.Respuesta,
          ErrorMessage: null
        };
      }
      case fromAdmModelos.AdmModeloActionTypes.FAIL_MODELO: {
        return {
            ...state,
            Operacion: 'FailModelo',
            Procesando: false,
            Respuesta: null,
            ErrorMessage: {...action.Respuesta}
        };
      }
      default: {
        return state;
      }
    }
  }
